<template>
  <div class="promotion-order-detail">
    <real-name-auth-gate @authenticated="refreshAfterAuthenticated">
      <template slot-scope="{ authenticated }">
        <el-card v-if="authenticated" class="page-card" shadow="never">
        <el-tabs v-model="activeTab" class="order-detail-tabs">
          <el-tab-pane label="订单推广明细" name="orderDetail">
            <!-- 查询区（与推广费分配明细共用） -->
            <promotion-search-bar ref="searchBar" :export-api="exportPromotionOrderList" @search="onSearch"></promotion-search-bar>
            <!-- 订单推广明细列表 -->
            <el-card shadow="never">
              <el-table v-loading="tableLoading" :data="tableData" size="small" stripe style="width: 100%">
                <!-- <el-table-column label="推广人姓名" prop="promoterName" min-width="100" align="center"></el-table-column> -->
                <el-table-column label="订单号" prop="orderId" min-width="200" align="center"></el-table-column>
                <el-table-column label="订单时间" prop="orderTime" min-width="160" align="center"></el-table-column>
                <el-table-column label="订单实付金额" prop="orderAmount" min-width="110" align="center"></el-table-column>
                <el-table-column label="订单推广比例" prop="promotionRate" min-width="110" align="center" :formatter="formatRate"></el-table-column>
                <el-table-column label="订单推广费" prop="promotionFee" min-width="110" align="center"></el-table-column>
                <el-table-column label="推广类型" prop="promotionTypeName" min-width="100" align="center"></el-table-column>
                <el-table-column label="交易类型" prop="tradeTypeName" min-width="100" align="center"></el-table-column>
                <el-table-column label="所属油站" prop="gasName" min-width="130" align="center"></el-table-column>
                <el-table-column label="所属商户" prop="companyName" min-width="170" align="center"></el-table-column>
              </el-table>
              <div class="pagination-wrap">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="pageChange"
                  :current-page="pagination.pageIndex"
                  :page-sizes="pageSizes"
                  :page-size="pagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalRow">
                </el-pagination>
              </div>
            </el-card>
          </el-tab-pane>
        </el-tabs>
        </el-card>
      </template>
    </real-name-auth-gate>
  </div>
</template>

<script>
import { queryPromotionOrderList, exportPromotionOrderList } from '@/api/promotionManage'
import PromotionSearchBar from '../components/promotionSearchBar'
import RealNameAuthGate from '../components/realNameAuthGate'


export default {
  name: 'promotionManage_promotionOrderDetail',
  components: {
    PromotionSearchBar,
    RealNameAuthGate
  },
  data () {
    return {
      activeTab: 'orderDetail',
      exportPromotionOrderList,
      tableLoading: false,
      tableData: [],
      totalRow: 0,
      lastSearchParams: {},
      activatedReady: false,
      pagination: {
        pageIndex: 1,
        pageSize: 10
      },
      pageSizes: [10, 50, 100, 200]
    }
  },
  activated () {
    // 该页面会被 keep-alive 缓存；从其他菜单切回来时 created 不会再触发，需要主动刷新列表。
    if (!this.activatedReady) {
      this.activatedReady = true
      return
    }
    this.$nextTick(async () => {
      if (this.$refs.searchBar) {
        await this.$refs.searchBar.initOptions()
        this.$refs.searchBar.search()
      }
    })
  },
  methods: {
    isSuccess (code) {
      return code === 0 || code === 200
    },
    refreshAfterAuthenticated () {
      this.$nextTick(async () => {
        if (!this.$refs.searchBar) return
        await this.$refs.searchBar.initOptions()
        this.$refs.searchBar.search()
      })
    },
    // 查询区触发查询
    onSearch (params) {
      this.lastSearchParams = params
      this.pagination.pageIndex = 1
      this.refresh()
    },
    // 分页页码改变
    pageChange (currentPage) {
      this.pagination.pageIndex = currentPage
      this.refresh()
    },
    // 分页条数改变
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageIndex = 1
      this.refresh()
    },
    buildQueryParams () {
      // 后端分页字段为 pageNum/pageSize，页面分页组件仍保留项目常用的 pageIndex。
      return {
        ...this.lastSearchParams,
        pageNum: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      }
    },
    normalizeRow (item) {
      // 表格列沿用页面通用字段名；这里把订单推广明细接口字段转换为展示字段。
      return {
        ...item,
        orderId: item.orderId || item.orderNo,
        orderTime: item.orderTime || item.payDt,
        orderAmount: item.orderAmount || item.oilPayAmount,
        gasName: item.gasName || item.distributeGasName,
        companyName: item.companyName || item.distributeCompanyName,
        promotionRate: item.promotionRate || item.commissionRate,
        promotionFee: item.promotionFee || item.commissionAmount,
        tradeTypeName: item.tradeTypeName || item.transactionTypeName
      }
    },
    // 获取列表数据
    async refresh () {
      this.tableLoading = true
      try {
        const params = this.buildQueryParams()
        const { code, result = [], totalRow = 0 } = await queryPromotionOrderList(params)
        if (!this.isSuccess(code)) {
          this.tableData = []
          this.totalRow = 0
          return
        }
        const list = Array.isArray(result) ? result : (result.list || [])
        this.tableData = list.map(this.normalizeRow)
        this.totalRow = parseInt(totalRow || result.total || 0)
      } catch (err) {
        this.tableData = []
        this.totalRow = 0
      } finally {
        this.tableLoading = false
      }
    },
    // 推广比例展示
    formatRate (row, column, cellValue) {
      return cellValue === null || cellValue === undefined ? '--' : `${cellValue}%`
    }
  }
}
</script>

<style lang="less" scoped>
.promotion-order-detail {
  width: 100%;
  min-width: 0;
  overflow-x: hidden;

  .page-card {
    min-width: 0;
    margin-top: 30px;
  }

  /deep/ .order-detail-tabs {
    min-width: 0;
  }

  /deep/ .order-detail-tabs > .el-tabs__header {
    margin: 0 0 15px;
  }

  .pagination-wrap {
    padding: 15px 0 5px;
    text-align: right;
  }
}
</style>
